export interface AssociatedContactSummary {
  id: string;
  firstName: string | null;
  lastName: string | null;
}

export interface ContactSummary {
  id: string;
  name: string;
  contactDetails: string | null;
  contactType: string | null;
  entityType: EntityType | null;
  portfolio: string | null;
  nmbAffiliateId?: string | null;
  tags?: string[];
}

export enum EntityType {
  Individual = 'Individual',
  Company = 'Company',
  Trust = 'Trust'
}

export const EntityTypeLabel = {
  [EntityType.Individual]: 'Individual',
  [EntityType.Company]: 'Company',
  [EntityType.Trust]: 'Trust'
};
